import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { HttpClientProvider } from '@services/http/client/http-client-provider';
import { Dettaglio } from '@components/servizi-soluzioni/dettaglio/dettaglio';
import { GetCategoriesDetailRemoteCall } from '@services/http/remote-calls/snf-api/categories/get-categories-detail.http-remote-call';
import { useSiteData } from '../../../../context/site-data-context';

export default function StoriaDetail() {
  const { idstoria, slide } = useParams();
  const intl = useIntl();
  const { serviceCategories, technologyCategories } = useSiteData();
  const [data, setData] = useState({
    translations: {},
    imageUrl: '',
    darkTheme: false
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const httpClient = HttpClientProvider.getInstance();
      const categoriesDetailRemoteCall = new GetCategoriesDetailRemoteCall(idstoria, intl.locale);
      const res = await httpClient.execute(categoriesDetailRemoteCall);
      if (!cancelled) setData(res);
    })();
    return () => {
      cancelled = true;
    };
  }, [idstoria, intl.locale]);

  return (
    <Dettaglio
      translations={data.translations}
      darkTheme={data.darkTheme}
      imageUrl={data.imageUrl}
      serviceCategories={serviceCategories}
      technologyCategories={technologyCategories}
      link={{ pathname: '/', hash: `storie-di-successo/${slide}` }}
    />
  );
}
